<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import ImageGalleryService from '@/services/imageGalleryService'

/**
 * This component acts as wrapper component for all the components that render images. This extracts images from child components and creates gallery out of it.
 */
export default {
  name: 'WithGallery',
  props: {
    /**
     * Gallery is re-created when this property changes
     */
    updateWatcher: {}
  },
  data() {
    return {
      gallery: new ImageGalleryService()
    }
  },
  methods: {
    /**
     * This can also be used by some parent components, if they want to re-create gallery
     */
    create() {
      this.gallery.create(this.$el)
    }
  },
  mounted() {
    const images = [...this.$el.querySelectorAll('img')].filter(
      node => !node.classList.contains('user-photo')
    )
    const hasImages = images.length > 0
    hasImages && this.create()
  },
  watch: {
    updateWatcher: 'create'
  }
}
</script>

<style scoped></style>
